<gc-system-tag *ngFor="let tag of currentTags" 
  [tag]="tag" 
  [readonly]="true">
</gc-system-tag>

<yc-button *ngIf="manageLinkVisible"
  [link]="true"
  [fontAwesomeIcon]="'tags'"
  [langKey]="'tags:linkSelectTags'"
  [defaultText]="'Select tags'"
  (onClick)="manageTags()">
</yc-button>